var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useGetDashletsPreferencesUserQuery, useGetImportableModulesQuery, useGetRelationshipWOpportunitiesMutation, useSaveDashletPreferencesMutation, } from "@/store/api";
import { useEffect, useMemo, useState } from "react";
import { LoaderImage } from "@/utils/loader";
import Chart from "./chart";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import moment from "moment";
import "moment/locale/fr";
import { calculateRanges, periods } from "@/components/forms/components/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPen, faRotateLeft } from "@fortawesome/pro-solid-svg-icons";
import EditChartKPI from "./editChartKPI";
import KpiSettingsPanel from "./kpiSettingsPanel";
moment.locale("fr");
var defaultPeriod = "semaine";
var defaultLimit = "La semaine dernière";
export var useKpiList = function () {
    var t = useTranslation(["common"]).t;
    return [
        {
            value: "CA",
            label: t("app.LBL_TOTAL_REVENUE", { ns: "common" }),
        },
        {
            value: "efficiency",
            label: t("app.LBL_OPPORTUNITY_CONVERSION_RATE", { ns: "common" }),
        },
        {
            value: "pipeline",
            label: t("app.LBL_SALES_PIPELINE", { ns: "common" }),
        },
        {
            value: "salesCycle",
            label: t("app.LBL_AVERAGE_SALES_CYCLE", { ns: "common" }),
        },
    ];
};
export default function WidgetKPIAffaires(_a) {
    var _this = this;
    var _b, _c;
    var widget = _a.widget;
    var t = useTranslation(["common", "Charts"]).t;
    var _d = useParams(), currentModule = _d.module, action = _d.action, record = _d.record;
    var kpiList = useKpiList();
    var payload = widget === null || widget === void 0 ? void 0 : widget.payload;
    var period = (payload === null || payload === void 0 ? void 0 : payload.period) || defaultPeriod;
    var limit = (payload === null || payload === void 0 ? void 0 : payload.limit) || defaultLimit;
    var dateRanges = calculateRanges(period, limit);
    var _e = useState([]), chartData = _e[0], setChartData = _e[1];
    var id = (widget === null || widget === void 0 ? void 0 : widget.payload.id) || "";
    var _f = useState(false), reinitialize = _f[0], setReinitialize = _f[1];
    var _g = useState(false), isPopupOpen = _g[0], setIsPopupOpen = _g[1];
    var _h = useState([]), allDashlets = _h[0], setAllDashlets = _h[1];
    var _j = useGetDashletsPreferencesUserQuery({}), preferenceDashlet = _j.data, loadGetDashlet = _j.isLoading;
    var _k = useGetRelationshipWOpportunitiesMutation(), getRelationshipWOpportunities = _k[0], _l = _k[1], dataRelation = _l.data, error = _l.error, isLoading = _l.isLoading;
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var currentRowMeta, result, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        if (!(payload === null || payload === void 0 ? void 0 : payload.isInDashlet)) return [3 /*break*/, 1];
                        currentRowMeta = (_a = widget === null || widget === void 0 ? void 0 : widget.rowMeta) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === id; });
                        //setChartData([]);
                        setChartData(currentRowMeta === null || currentRowMeta === void 0 ? void 0 : currentRowMeta.chartData);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, getRelationshipWOpportunities({
                            module: (payload === null || payload === void 0 ? void 0 : payload.kpiType) === "salesCycle"
                                ? ""
                                : currentModule
                                    ? currentModule
                                    : "",
                            body: {
                                cumulatif: (payload === null || payload === void 0 ? void 0 : payload.cumulatif) || "non",
                                periods: dateRanges,
                                kpiType: payload === null || payload === void 0 ? void 0 : payload.kpiType,
                                firstColor: payload === null || payload === void 0 ? void 0 : payload.firstColor,
                            },
                        }).unwrap()];
                    case 2:
                        result = _b.sent();
                        console.log("Fetchedd result:", result);
                        setChartData([]);
                        setChartData((result === null || result === void 0 ? void 0 : result.data) || []);
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _b.sent();
                        console.error("Failed to fetch relationship:", err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [widget, (_b = chartData === null || chartData === void 0 ? void 0 : chartData.data) === null || _b === void 0 ? void 0 : _b.length]);
    useEffect(function () {
        var _a;
        if (preferenceDashlet) {
            setAllDashlets((_a = preferenceDashlet === null || preferenceDashlet === void 0 ? void 0 : preferenceDashlet.data) === null || _a === void 0 ? void 0 : _a.dashlets);
        }
    }, [preferenceDashlet]);
    var editClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsPopupOpen(true);
            return [2 /*return*/];
        });
    }); };
    var _m = useSaveDashletPreferencesMutation(), saveDashletPreferences = _m[0], _o = _m[1], dashletLoad = _o.isLoading, isError = _o.isError, data = _o.data;
    var removeClick = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var currentDashlet, newDashlets, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentDashlet = Object.values(widget === null || widget === void 0 ? void 0 : widget.rowMeta).filter(function (item) {
                        return item.id !== id;
                    });
                    newDashlets = Object.values(allDashlets).map(function (row) {
                        if (row.id === widget.rowId) {
                            return __assign(__assign({}, row), { meta: currentDashlet });
                        }
                        else {
                            return row;
                        }
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce dashlet ?")) return [3 /*break*/, 3];
                    return [4 /*yield*/, saveDashletPreferences({
                            dashlets: newDashlets,
                            isNew: false,
                        }).unwrap()];
                case 2:
                    result = _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Failed to save widgets:", error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { children: (payload === null || payload === void 0 ? void 0 : payload.isInDashlet) ? (_jsxs("div", __assign({ id: "grid", className: "m-2 dark:bg-[var(--colors-bg-default)] p-2 rounded-md shadow sm:p-4 relative grid-container" }, { children: [(dashletLoad || loadGetDashlet) && _jsx(LoaderImage, {}), _jsxs("div", __assign({ className: "border-b-2 mb-4 flex flex-row justify-between" }, { children: [_jsx("h3", __assign({ className: "uppercase font-bold my-2" }, { children: payload === null || payload === void 0 ? void 0 : payload.title })), _jsxs("div", __assign({ className: "flex flex-row justify-end" }, { children: [_jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: editClick, title: "Editer" }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: function () {
                                        setReinitialize(!reinitialize);
                                        //refreshChart();
                                    }, title: "Retourner" }, { children: _jsx(FontAwesomeIcon, { icon: faRotateLeft, className: "text-gray-400" }) })), _jsx("button", __assign({ className: "hover:bg-red-500 p-1 rounded-md", onClick: removeClick, title: "Supprimer" }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "text-gray-400 hover:text-white" }) }))] }))] })), _jsx(Chart, { chartData: chartData, chartType: payload === null || payload === void 0 ? void 0 : payload.chartType, symbol: (payload === null || payload === void 0 ? void 0 : payload.kpiType) === "efficiency"
                        ? ["", "%"]
                        : (payload === null || payload === void 0 ? void 0 : payload.kpiType) === "salesCycle"
                            ? ["", " j"]
                            : ["$", "K"] }), isPopupOpen && (_jsx(EditChartKPI, { isOpen: isPopupOpen, onClose: function () { return setIsPopupOpen(false); }, title: (payload === null || payload === void 0 ? void 0 : payload.title) || "", records: widget, id: id, allDashlets: allDashlets }))] }))) : (_jsxs("div", { children: [isLoading && _jsx(LoaderImage, {}), _jsx("label", __assign({ className: " font-medium text-lg" }, { children: (payload === null || payload === void 0 ? void 0 : payload.title) || "Chiffre d’affaires réalisé" })), _jsx(Chart, { chartData: chartData, chartType: payload === null || payload === void 0 ? void 0 : payload.chartType, symbol: (payload === null || payload === void 0 ? void 0 : payload.kpiType) === "efficiency"
                        ? ["", "%"]
                        : (payload === null || payload === void 0 ? void 0 : payload.kpiType) === "salesCycle"
                            ? ["", " j"]
                            : ["$", "K"] })] }, payload.chartType)) }, (_c = chartData === null || chartData === void 0 ? void 0 : chartData.data) === null || _c === void 0 ? void 0 : _c.length));
}
export function WidgetSettings(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var widget = _a.widget, onChange = _a.onChange;
    var _j = useGetImportableModulesQuery(null), menuResponse = _j.data, isLoading = _j.isLoading;
    var _k = useParams(), module = _k.module, action = _k.action, record = _k.record;
    var kpiList = useKpiList();
    var _l = useState(((_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.cumulatif) || "non"), cumulatif = _l[0], setCumulatif = _l[1];
    var _m = useState(((_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.period) || defaultPeriod), period = _m[0], setPeriod = _m[1];
    var _o = useState(((_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.limit) || defaultLimit), limit = _o[0], setLimit = _o[1];
    var _p = useState((_e = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _e === void 0 ? void 0 : _e.kpiType), kpiType = _p[0], setKpiType = _p[1];
    var optionsGraph = ((_f = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _f === void 0 ? void 0 : _f.kpiType) !== "pipeline"
        ? [
            { value: "texte", label: "Texte" },
            { value: "horizontalBar", label: "Barres" },
            { value: "bar", label: "Colonnes" },
            { value: "line", label: "Linéaire" },
        ]
        : [
            { value: "texte", label: "Texte" },
            { value: "funnelGraph", label: "Funnel" },
        ];
    var limitOptionsByPeriod = {
        heure: ["Les dernières 24h"],
        jour: [
            "Les 2 derniers jours",
            "Les 7 derniers jours",
            "Hier",
            "Avant-hier",
        ],
        semaine: ["Les 30 derniers jours", "La semaine dernière"],
        mois: [
            "Les 90 derniers jours",
            "Les derniers 6 mois",
            "Le mois dernier",
            "Le trimestre dernier",
        ],
        trimestre: ["Le trimestre dernier", "Les derniers 6 mois"],
        semestre: ["Le semestre dernier", "L'année dernière"],
        année: ["L'année dernière", "Les 2 dernières années"],
    };
    var availableLimits = useMemo(function () {
        return limitOptionsByPeriod[period] || [];
    }, [period]);
    var handleChangeCumulatif = function (event) {
        setCumulatif(event.target.value);
        onChange &&
            onChange(widget, __assign(__assign({}, widget.payload), { cumulatif: event.target.value }));
    };
    var _q = useState((_g = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _g === void 0 ? void 0 : _g.title), titleChart = _q[0], setTitleChart = _q[1];
    var _r = useState((_h = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _h === void 0 ? void 0 : _h.firstColor), firstColor = _r[0], setFirstColor = _r[1];
    return (_jsx("div", __assign({ className: "space-y-1 px-2" }, { children: _jsx(KpiSettingsPanel, { titleChart: titleChart, setTitleChart: setTitleChart, kpiType: kpiType, setKpiType: function (value) {
                var _a;
                setKpiType(value);
                onChange &&
                    onChange(widget, __assign(__assign({}, widget === null || widget === void 0 ? void 0 : widget.payload), { kpiType: value, title: ((_a = kpiList.find(function (item) { return item.value === value; })) === null || _a === void 0 ? void 0 : _a.label) || "" }));
            }, module: module, chartType: widget === null || widget === void 0 ? void 0 : widget.payload.chartType, setChartType: function (value) {
                onChange && onChange(widget, __assign(__assign({}, widget.payload), { chartType: value }));
            }, period: period, setPeriod: function (value) {
                setPeriod(value);
                onChange && onChange(widget, __assign(__assign({}, widget.payload), { period: value }));
            }, limit: limit, setLimit: function (value) {
                setLimit(value);
                onChange && onChange(widget, __assign(__assign({}, widget.payload), { limit: value }));
            }, firstColor: firstColor, setFirstColor: function (value) {
                setFirstColor(value);
                onChange &&
                    onChange(widget, __assign(__assign({}, widget.payload), { firstColor: value }));
            }, cumulatif: cumulatif, handleChangeCumulatif: handleChangeCumulatif, kpiList: kpiList, optionsGraph: optionsGraph, availableLimits: availableLimits, periods: periods }) })));
}
widgetsDictionary.register("widget/KPIAffaires", {
    name: "Widget KPI Affaires",
    display: WidgetKPIAffaires,
    settings: WidgetSettings,
    icon: "/themes/etcrm2/images/icon_Charts_Vertical_32.gif",
    selectable: true,
});
